// bao migrate skip

import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
export interface DateTimePickerComponentParams {
    acceptCustomValue: boolean;
    applyButtonText: string;
    cancelButtonText: string;
    type: 'date' | 'datetime' | 'time';
    pickerType: 'calendar' | 'list' | 'native' | 'rollers';
    value: KnockoutObservable<any>;
    disabled?: boolean;
    showDropdownButton: boolean;
    dateOutOfRangeMessage?: string;
    displayFormat?: string;
    height?: number;
    width?: number;
    min?: string;
    max?: string;
    readonly?: boolean;
    showClearButton?: boolean;
}
export class DateTimePickerComponent {
    dataTimePickerOptions;
    valueObservable: KnockoutObservable<any>;
    DateTimePickerHTML: KnockoutObservable<HTMLElement> = ko.observable<HTMLElement>();
    constructor(params: {
        options: DateTimePickerComponentParams;
    }, componentElement: HTMLElement) {
        if (!params) {
            throw new Error('Params are not set');
        }
        this.dataTimePickerOptions = params.options;
        this.valueObservable = params.options.value;
        this.dataTimePickerOptions.value = params.options.value();
        this.dataTimePickerOptions.onValueChanged = (e) => { this.onDataChange(e); };
        $(this.DateTimePickerHTML()).dxDateBox(this.dataTimePickerOptions);
    }
    onDataChange(e) {
        this.valueObservable(this.dataTimePickerOptions.value);
    }
}